import React, { useState, useEffect } from "react";
import { investorApi } from "../api/api";
import PropertyList from "../components/Header/Property/PropertyList";


const Home = ({searchQuery}) => {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await investorApi.getAllProperties();
        if (response.status === 200) {
          setProperties(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch properties:", error);
      }
    };

    fetchProperties();
  }, []);

  return (
    <div style={{ padding: "24px" }}>
      {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
        {properties.map((property) => (
          <div
            key={property.Pid}
            style={{
              width: "calc(25% - 18px)",
              minWidth: "250px",
              height: "370px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <img
              src={property.iconUrl}
              alt={property.PropertyName}
              style={{ width: "100%", height: "180px", objectFit: "cover" }}
            />
            <div style={{ padding: "16px", flexGrow: 1 }}>
              <h3
                style={{
                  margin: "0 0 8px",
                  fontSize: "18px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {property.PropertyName}
              </h3>
              <p style={{ margin: "0 0 6px", color: "#555", fontSize: "14px" }}>
                {property.Address}, {property.City}
              </p>
              <p style={{ margin: "4px 0", fontSize: "14px" }}>
                <strong>SqFt:</strong> {property.SizeInSqFt}
              </p>
              <p style={{ margin: "4px 0", fontSize: "14px" }}>
                <strong>Rate:</strong> ₹{property.SqFtPrice} / sqft
              </p>
              <p
                style={{
                  margin: "8px 0 0",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                <strong>Total:</strong> ₹
                {parseInt(property.OriginalPropertyValue).toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div> */}
      <PropertyList searchQuery={searchQuery} />
     
    </div>
  );
};

export default Home;
